import { render, staticRenderFns } from "./ActionOpenChat.vue?vue&type=template&id=79c425ac&"
import script from "./ActionOpenChat.vue?vue&type=script&lang=js&"
export * from "./ActionOpenChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports